export const calendarModes = {
  READ_ONLY: 'ReadOnly',
  READ_WRITE: 'ReadWrite',
};
